import React, { useState } from 'react';

const CtaForm = () => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        company: ''
    });
    const [errors, setErrors] = useState({
        name: '',
        email: '',
        company: ''
    });
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
  
    const validate = () => {
        let formIsValid = true;
        let errors = {};
        if (!formData.name) {
            formIsValid = false;
            errors.name = 'Nombre es requerido';
        }

        if (!formData.email) {
            formIsValid = false;
            errors.email = 'Email es requerido';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            formIsValid = false;
            errors.email = "Email es invalido";
        }
   
        if (!formData.company) {
            formIsValid = false;
            errors.company = 'Compañia es requerida';
        }

        setErrors(errors);
        return formIsValid;

    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            console.log('Formulario enviado correctamente',);
        }
    };

    return (
        <form className="cta_form" onSubmit={handleSubmit}>
            <div className="input_filled">
                <input type="text" name='name' value={formData.name} onChange={handleChange} placeholder="Tu nombre completo*" />
                {errors.name && <span className='error'>{errors.name}</span>}
            </div>
            <div className="input_filled">
                <input type="text" name="email" placeholder="Correo electrónico*" value={formData.email} onChange={handleChange} />
                {errors.email && <span className="error">{errors.email}</span>}
            </div>
            <div className="input_filled">
                <input type="text" name="company" placeholder="Compañía*" value={formData.company} onChange={handleChange} />
                {errors.company && <span className="error">{errors.company}</span>}
            </div>
            <div className="input_filled">
                <button type="submit" >Enviar</button>
            </div>
        </form>
    );
};

export default CtaForm;